<template>
    <div class="input-group">
        <input v-on:keyup.enter="search()" placeholder="Admin search..." type="search" ref="search" v-model="q"
               class="form-control">
        <button @click="search()" class="btn btn-light" type="button"><i class="fal fa-search"></i></button>
    </div>
</template>

<script>
export default {
    name: "admin-search-input",
    data() {
        return {q: ''}
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        let q = urlParams.get('q')
        if (q) {
            this.q = q;
        }
        console.log('search');
        if (window.$userID) {
            $api.auth.isOnline();
            setInterval(() => {
                $api.auth.isOnline();
            }, 1000 * 600);
        }
    },
    methods: {
        toggle() {
            if (window.innerWidth <= 567) {
                const menuToggle = document.getElementById('topNavbarNavDropdown')
                const bsCollapse = new bs.Collapse(menuToggle, {toggle: false})
                bsCollapse.toggle();
            }
        },

        search() {
            const mountPoint = document.querySelector('#app');
            const params = new URLSearchParams('q=' + this.q);
            let url = '/admin/users?q=' + params.get('q');
            if (mountPoint) {
                window.router.push(url)
                this.toggle();
            } else {
                window.open(url, "_self")
            }
        },
    }
}
</script>

<style lang="scss" scoped>



    input {
    border-color: white;
}
</style>
